import React from "react";
import { Leaf } from "lucide-react";
import PaperCharm from "./PaperCharm";

export default function PageHeading({ icon: Icon, children, charm = "ginkgo" }) {
  return (
    <div className="paper-page-heading">
      <h2><span className="paper-heading-icon"><Icon size={22} aria-hidden="true" /></span>{children}</h2>
      <div className="paper-heading-art" aria-hidden="true">
        <Leaf className="hanging-leaf" size={15} />
        <PaperCharm kind={charm} />
      </div>
    </div>
  );
}
